import request from '../helpers/request';

const getRequestCommentAttachment = async (commentId, fileName) => {
  return await request.get(
    `/Request/request_note_attachment`,
    {
      noteId: commentId,
      fileName
    },
    'Не удалось загрузить файл',
    ''
  );
};

export default getRequestCommentAttachment;

